import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'invoicesList': [],
  'invoicesItem': [],
  'invoicesCombos': [],
  'loading': false,
  'loadingItem': false,
};

export const partInvoices = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_INVOICES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_INVOICES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'invoicesList': action.response.data,
    }),
    [ActionTypes.FETCHED_INVOICES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'invoicesList': [],
    }),
    [ActionTypes.CLEAR_INVOICE_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    // ITEMS
    [ActionTypes.FETCHING_INVOICE_ITEM]: (state, action) => ({
      ...state,
      'loadingItem': true,
    }),
    [ActionTypes.FETCHED_INVOICE_ITEM]: (state, action) => ({
      ...state,
      'loadingItem': false,
      'invoicesItem': action.response.data,
    }),
    [ActionTypes.FETCHED_INVOICE_ITEM_FAILED]: (state, action) => ({
      ...state,
      'loadingItem': false,
      'invoicesItem': [],
    }),
    // COMBOS
    [ActionTypes.FETCHING_INVOICE_COMBOS]: (state, action) => ({
      ...state,
      'loadingItem': true,
    }),
    [ActionTypes.FETCHED_INVOICE_COMBOS]: (state, action) => ({
      ...state,
      'loadingItem': false,
      'invoicesCombos': action.response.data,
    }),
    [ActionTypes.FETCHED_INVOICE_COMBOS_FAILED]: (state, action) => ({
      ...state,
      'loadingItem': false,
      'invoicesCombos': [],
    }),
  })(state, action);
};
